<template>
  <ErrorPage
    status-code="403"
    status-message="NOT ALLOWED"
  />
</template>

<script lang="ts" setup>
import ErrorPage from './components/error_page.vue';
</script>
